import styled from 'styled-components/macro'

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  width: 14px;
  max-width: 14px;
  margin-right: 10px;
`
